import { memo } from 'react';
import { MButton } from '@Components/Base';
import { Form } from 'antd';

interface EditSubmittedButtonsProps {
  disabledSaveForm: boolean;
  disabledCancelForm: boolean;
  onCancel: () => void;
  onSaveAsDraft: () => void;
}

const EditSubmittedButtons: React.FC<EditSubmittedButtonsProps> = ({
  disabledSaveForm,
  disabledCancelForm,
  onCancel,
  onSaveAsDraft,
}) => {
  return (
    <>
      <Form.Item>
        <MButton
          type="secondary"
          disabled={disabledSaveForm || disabledCancelForm}
          onClick={onCancel}
        >
          Cancel Request
        </MButton>
      </Form.Item>
      <Form.Item>
        <MButton
          type="primary"
          onClick={onSaveAsDraft}
          disabled={disabledSaveForm}
        >
          Save Changes
        </MButton>
      </Form.Item>
    </>
  );
};

export default memo(EditSubmittedButtons);
